<template>
    <div className="page">
      <div className="card">
        <div class="hero">
          <a className="twitter" href="https://twitter.com/astromojis">
          Twitter
        </a>
          <a className="opensea" href="https://opensea.io/collection/astromojis-official" >
          Opensea
        </a>
          <a className="contract"
          href="https://etherscan.io/address/0xe938e4b8ce51eeacc4c4454a08b59f70ee9c2293"
        > <!--- @production change contract link --->
          Contract
        </a>
          <img class="heroimg" src="../assets/hero.gif"/>
        </div>
        <ArtCollection />
      </div>
    </div>
</template>


<script>
import ArtCollection from './Minter.vue'

export default {
    components: {
        ArtCollection
    }
}
</script>


<style lang='scss'>
.twitter {
  top:5px;
  position: absolute;
  left: 100px;
  color: white;
  z-index: 2;
}
.opensea{
  top:5px;
  position: absolute;
  color: white;
  z-index: 3;
}
.contract{
  top:5px;
  position: absolute;
  right: 100px;
  color: white;
  z-index: 4;
} 
@media (max-width:500px) {
  .twitter {
  top:5px;
  position: absolute;
  left: 20px;
  color: white;
  z-index: 2;
}
.opensea{
  top:5px;
  position: absolute;
  color: white;
  z-index: 3;
}
.contract{
  top:5px;
  position: absolute;
  right: 20px;
  color: white;
  z-index: 4;
} 
}
.WalletButton {
    top: 14vh;
    position: absolute;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border: none;
    color: red;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 25px;
    cursor: pointer;
    &:hover {
    box-shadow: 0 0 20px 0px rgb(160, 142, 142);
    -webkit-box-shadow: 0 0 20px 0px rgb(160, 142, 142);
    -moz-box-shadow: 0 0 20px 0px rgb(160, 142, 142);
  }
}
.ConectedWallet{
    top: 14vh;
    position: absolute;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 25px;
    background: green;
}

.hero {
    display: flex;
    justify-content: center;
}
.heroimg {
    margin-top: 20vh;
    margin-bottom:20px;
    width: 375px;
    height: auto;
    position: center;;
}

@media (max-width: 375px) {
    .heroimg {
    margin-top: 20vh;
    width: 230px;
    }
}

</style>